import React, { useState, useEffect } from "react";
import EmailTemplatesForm from "../../../forms/EmailTemplatesForm";
import Confirm from "../../../../base/Confirm";
import ListView from "../../../../base/ListView";
import {
  createEmailTemplate,
  deleteEmailTemplate,
  getEmailTemplate,
  getEmailTemplates,
  updateEmailTemplate
} from "../../../../services/api/emailTemplates";
import { ajaxErrorHandler, defaultSuccess } from "../../../../libs/utils";
import { history } from "../../../../redux/store";
import { getEmailTemplateTypes } from "../../../../services/api/emailTemplateTypes";

const EmailTemplates = ({ event, match }) => {
  const [template, setTemplate] = useState();
  const [templates, setTemplates] = useState([]);
  const [templatesMeta, setTemplatesMeta] = useState([]);
  const [allTypes, setAllTypes] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [filters, setFilters] = useState({
    "page[number]": 1,
    "page[size]": 50,
    sort: "-updated_at"
  });

  // Load all templates + types on page load
  useEffect(() => {
    getTypes();
  }, []);

  useEffect(() => {
    getTemplates();
  }, [filters]);

  // Load current template if ID is present or on change
  useEffect(() => {
    if (match.params.emailTemplateId) {
      getEmailTemplate(match.params.emailTemplateId)
        .then(response => {
          setTemplate(response);
        })
        .catch(ajaxErrorHandler);
    }
  }, [match.params.emailTemplateId]);

  const getTemplates = () => {
    getEmailTemplates(filters).then(response => {
      setTemplates(response.data);
      setTemplatesMeta(response.meta);
    });
  };

  const getTypes = () => {
    getEmailTemplateTypes().then(response => {
      setAllTypes(response.data);
    });
  };

  const handleCreate = values => {
    const data = {
      body: values.body,
      filename: "ja",
      type: values.type,
      subject: values.subject
    };

    setIsCreating(true);
    createEmailTemplate(data)
      .then(response => {
        defaultSuccess("Created");
        getTemplates();
        setIsCreating(false);
      })
      .catch(ajaxErrorHandler);
  };

  const handleUpdate = values => {
    const data = {
      body: values.body,
      filename: "ja",
      type: values.type,
      subject: values.subject
    };

    updateEmailTemplate(values.id, data)
      .then(response => {
        defaultSuccess("Updated");
        history.push("/admin/emails");
      })
      .catch(ajaxErrorHandler);
  };

  const handleDelete = id => {
    Confirm(
      "Are you sure you want to delete this emailTemplate? This action can not be undone, please make sure no festival is using this emailTemplate.",
      {
        title: "Delete EmailTemplate",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        deleteEmailTemplate(id)
          .then(response => {
            defaultSuccess("Deleted");
            getTemplates();
          })
          .catch(ajaxErrorHandler);
      },
      result => {}
    );
  };

  // Look what types have not been used yet for this festival by filtering all types by the existing templates
  const usedTypes = templates.map(template => template.type);
  const filteredTypes = allTypes.filter(
    type => usedTypes.indexOf(type.type) === -1 && type.global
  );
  const types = Object.entries(filteredTypes).map(type => type[1].type);

  // Config for the list
  const listViewConf = {
    dataSet: templates.filter(template => template.eventId === null),
    dataMeta: templatesMeta,
    columns: [
      {
        key: "type",
        value: "Type",
        sort: "type"
      }
    ],
    baseFilters: filters,
    actions: {
      deleteLink: true,
      editLink: true,
      detailsLink: false,

      deleteFunction: handleDelete
    },
    url: "/admin/emails"
  };

  return (
    <div className="m-content">
      <div className="row">
        <div className="col-xl-6">
          <ListView
            config={listViewConf}
            handleDelete={handleDelete}
            handleFilterUpdate={setFilters}
          />
        </div>
        <div className="col-xl-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-map-location" />
                  </span>
                  <h3 className="m-portlet__head-text">
                    {template ? "Edit Email Template" : "Create Email Template"}
                  </h3>
                </div>
              </div>
            </div>
            <EmailTemplatesForm
              onSubmit={template ? handleUpdate : handleCreate}
              isCreating={isCreating}
              emailTemplate={template}
              event={event}
              emailTemplateTypes={types}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplates;
